import { Toc } from "./types";

export interface InitialRoute {
  routeId: string;
  subTarget?: { screenId: string };
  warning?: string;
}

export const screenIdNotFoundMessage = (screenId: string): string =>
  `screenId: ${screenId} does not exist in this course`;

export const resolveInitialRoute = (structure: Toc, screenId: string): InitialRoute => {
  if (!screenId) {
    return { routeId: structure.firstRenderId };
  }

  if (structure.screens.some((screen) => screen.elementId === screenId)) {
    return { routeId: screenId };
  }

  // Web stitched-lesson child screens are not in `screens`; they are routed through
  // their parent, the same call shape the TOC buttons emit (TocHtmlBuilder.ts)
  const stitched = structure.tocStitchedLessonMap?.get(screenId);
  if (stitched?.isScreen) {
    return { routeId: stitched.elementToRoute, subTarget: { screenId } };
  }

  return { routeId: structure.firstRenderId, warning: screenIdNotFoundMessage(screenId) };
};
